import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface IMobileItem {
    isActive: boolean;
    isSelected: boolean;
}

const OFFSET_FROM_TOP = '180px';
export const StyledMobileMenu = styled.ul`
    line-height: 2;
    overflow: auto;
    max-height: calc(100vh - ${OFFSET_FROM_TOP});
    margin-top: 20px;
    padding: 0;
`;

export const StyledMobileItem = styled.li<IMobileItem>`
    cursor: pointer;
    display: block;
    list-style: none;
    padding-left: 67px;
    font-size: 16px;
    line-height: 32px;
    color: ${(props) => props.theme.shades.blackGrey};
    ${(props) =>
        props.isActive
            ? css`
                  background: ${props.theme.colors['main8']};
                  color: ${props.theme.shades.white};
              `
            : ``}
    ${(props) =>
        !props.isActive && props.isSelected
            ? css`
                  background: ${props.theme.shades.lightGrey};
              `
            : ``}
`;

export const StyledHeaderItem = styled(StyledMobileItem)`
    font-weight: 700;
    line-height: 40px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.33);
`;

export const StyledSubHeaderItem = styled(StyledMobileItem)`
    font-weight: 700;
    cursor: default;
`;

export const StyledMobileInput = styled.input`
    height: 50px;
    width: 100%;
    box-shadow: ${(props) => props.theme.boxShadow.modalInput};
    border: solid 1px rgba(155, 155, 155, 0.36);
    padding-left: 60px;
    padding-right: 25px;
    font-size: 14px;
    line-height: 1.29;
    color: ${(props) => props.theme.shades.blackGrey};
`;
